/** 全站共用 loading:整頁 overlay(頁面初始化/導航)+ 按鈕型 spinner。
 *  自 public/js/loading.js 移植;模組載入即啟動(type="module" 為 defer,DOM 已可用)。
 */
let count = 0;
let safetyTimer: number | undefined;
let overlay: HTMLDivElement | null = null;

const SAFETY_MS = 15000; // 保險:逾時強制關閉,避免例外未走到 hide 而卡死畫面

function ensureOverlay(): HTMLDivElement {
  if (overlay) return overlay;
  overlay = document.createElement('div');
  overlay.className = 'ekm-loading is-hidden';
  overlay.innerHTML =
    '<div class="ekm-loading__spinner"></div>' +
    '<div class="ekm-loading__text">載入中…</div>';
  document.body.appendChild(overlay);
  return overlay;
}

export function show(text?: string): void {
  const el = ensureOverlay();
  const label = el.querySelector<HTMLElement>('.ekm-loading__text');
  if (label) label.textContent = text || '載入中…';
  count += 1;
  el.classList.remove('is-hidden');
  window.clearTimeout(safetyTimer);
  safetyTimer = window.setTimeout(hideAll, SAFETY_MS);
}

export function hide(): void {
  count = Math.max(0, count - 1);
  if (count === 0 && overlay) {
    overlay.classList.add('is-hidden');
    window.clearTimeout(safetyTimer);
  }
}

export function hideAll(): void {
  count = 0;
  if (overlay) overlay.classList.add('is-hidden');
  window.clearTimeout(safetyTimer);
}

export function wrap<T>(promise: Promise<T> | T, text?: string): Promise<T> {
  show(text);
  return Promise.resolve(promise).finally(hide);
}

/** 按鈕型 loading:disabled + 小 spinner + 文字切換,不蓋全頁 */
export async function withButton<T>(
  btn: HTMLButtonElement, busyText: string, asyncFn: () => Promise<T>,
): Promise<T | undefined> {
  if (btn.disabled) return undefined;
  const original = btn.innerHTML;
  btn.disabled = true;
  btn.innerHTML = `<span class="ai-spin"></span>${busyText}`;
  try {
    return await asyncFn();
  } finally {
    btn.disabled = false;
    btn.innerHTML = original;
  }
}

/** 程式導航前先顯示 overlay */
export function nav(url: string, text?: string): void {
  show(text || '頁面載入中…');
  window.location.href = url;
}

show(); // 頁面初始化期間先顯示

// 點擊站內連結導航時顯示 overlay
document.addEventListener('click', (e) => {
  if (e.defaultPrevented || e.ctrlKey || e.metaKey || e.shiftKey || e.altKey || e.button !== 0) return;
  const target = e.target as Element | null;
  const a = target?.closest?.('a[href]') as HTMLAnchorElement | null;
  if (!a) return;
  const href = a.getAttribute('href') || '';
  if (!href || href.startsWith('#') || href.startsWith('javascript:')) return;
  if (a.target === '_blank' || a.hasAttribute('download')) return;
  if (a.origin && a.origin !== window.location.origin) return;
  show('頁面載入中…');
}, true);

// 瀏覽器上一頁(bfcache)還原時清掉殘留 overlay
window.addEventListener('pageshow', (e) => {
  if (e.persisted) hideAll();
});
